module.exports = __webpack_public_path__ + "img/Instacart_logo.d5f4fa4f.png";